import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../../context-store";
import { EMAIL_RULE, MOBILE_NUMBER_RULE, OBJECT_DESCRIPTION_RULE_REQUIRED, OBJECT_NAME_RULE, WEBSITE_RULE } from "../../../utils/validation-utils";
import { useForm } from "react-hook-form";
import fileUploadService from '../../../services/file-upload-service';
import toasterUtils from "../../../utils/toaster-utils";
import { FileUploadTypeEnum } from "../../../models/enums/FileUploadTypeEnum";
import fileUtils from "../../../utils/file-utils";
import loaderUtils from "../../../utils/loader-utils";
import CompanyProfileRequest from "../../../models/company/dashboard/request/CompanyProfileRequest";
import modalUtils from "../../../utils/modal-utils";
import candidateService from "../../../services/candidate/candidate-service";
import companyDashboardService from "../../../services/company/dashboard-service";
import { GuidEnum } from "../../../models/enums/GuidEnum";
import { useHistory } from "react-router";
import { Button, FormControl, FormHelperText, InputLabel, TextField } from "@mui/material";

interface CompanyProfileProps {
    objCompanyProfile: CompanyProfileRequest;
}

const InterviewsComponent = (props: CompanyProfileProps) => {
    const history = useHistory();
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [isResumeUploaded, setIsResumeUploaded] = useState<boolean>(false);

    const {
        register,
        setValue,
        getValues,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<CompanyProfileRequest>({
        mode: "onChange",
        defaultValues: props.objCompanyProfile
    });

    useEffect(() => {
        clearFile();
        if (props.objCompanyProfile.resumeTitle) {
            setIsResumeUploaded(true);
        }
    }, []);

    const hiddenFileInput: any = React.useRef();
    const browseFileHandler = (event: any) => {
        event.preventDefault();
        hiddenFileInput.current.click();
    };

    const clearFile = () => {
        hiddenFileInput.current.value = "";
    };

    function uploadLogo(e: any): void {
        const data = new FormData();
        data.append("file", e.target.files[0]);
        data.append("fileName", e.target.files[0].name);
        data.append("userId", loggedInUser ? loggedInUser.profileId : "");
        data.append("fileUploadType", FileUploadTypeEnum.CompanyLogo.toString());
        modalUtils.showLoader();
        fileUploadService.uploadFile(data).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            toasterUtils.showSuccess(res.informationMessages.toString());
            setIsResumeUploaded(true);
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const downloadLogo = () => {
        if (loggedInUser) {
            modalUtils.showLoader();
            candidateService.downloadCandidateResume(loggedInUser.profileId, FileUploadTypeEnum.CompanyLogo.toString()).then((res) => {
                modalUtils.closeModal();
                fileUtils.downloadFile(res, props.objCompanyProfile.resumeTitle);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        }
    };

    const onSubmit = (formData: CompanyProfileRequest) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        if (isResumeUploaded) {
            formData.companyId = loggedInUser ? loggedInUser.profileId : GuidEnum.Empty;
            modalUtils.showLoader();
            companyDashboardService.saveCompanyProfile(formData).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                toasterUtils.showSuccess(res.informationMessages.toString());
                setTimeout(() => {
                    history.push("/company-dashboard");
                }, 1000);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        } else {
            toasterUtils.showWarning("Please Upload Resume to Save Profile.");
        }
    };


    return (
        <div className="card card-white">
            <div className="card-body">
                <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
                    <div className="quform-elements">
                        <div className="row">
                            <div className="col-md-6">
                                <FormControl fullWidth margin="normal" error={!!errors.mobileNumber}>
                                    <TextField type="text" label="Mobile Number" size="small" {...register("mobileNumber", MOBILE_NUMBER_RULE)} error={!!errors.mobileNumber}
                                        helperText={errors.mobileNumber?.message} autoComplete="off" required />
                                </FormControl>
                            </div>
                            <div className="col-md-6">
                                <FormControl fullWidth margin="normal" error={!!errors.website}>
                                    <TextField type="text" label="Website" size="small" {...register("website", WEBSITE_RULE)} error={!!errors.website}
                                        helperText={errors.website?.message} autoComplete="off" placeholder="Website" required />
                                </FormControl>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <FormControl fullWidth margin="normal" error={!!errors.contactPersonName}>
                                    <TextField type="text" label="Contact Person Name" size="small" {...register("contactPersonName", OBJECT_NAME_RULE)} error={!!errors.contactPersonName}
                                        helperText={errors.contactPersonName?.message} autoComplete="off" placeholder="Contact Person Name" required />
                                </FormControl>
                            </div>
                            <div className="col-md-6">
                                <FormControl fullWidth margin="normal" error={!!errors.contactPersonPhoneNumber}>
                                    <TextField type="text" label="Contact Person Phone" size="small" {...register("contactPersonPhoneNumber", MOBILE_NUMBER_RULE)} error={!!errors.contactPersonPhoneNumber}
                                        helperText={errors.contactPersonPhoneNumber?.message} autoComplete="off" placeholder="Contact Person Phone" required />
                                </FormControl>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <FormControl fullWidth margin="normal" error={!!errors.contactPersonEmailId}>
                                    <TextField type="email" label="Contact Person Email" size="small" {...register("contactPersonEmailId", EMAIL_RULE)} error={!!errors.contactPersonEmailId}
                                        helperText={errors.contactPersonEmailId?.message} autoComplete="off" placeholder="Contact Person Email" required />
                                </FormControl>
                            </div>
                            <div className="col-md-6">
                                <FormControl fullWidth margin="normal" error={!!errors.address}>
                                    <TextField label="Address" size="small" multiline rows={3} {...register("address", OBJECT_DESCRIPTION_RULE_REQUIRED)} error={!!errors.address}
                                        helperText={errors.address?.message} autoComplete="off" placeholder="Address" required />
                                </FormControl>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <FormControl fullWidth margin="normal">
                                    <InputLabel shrink>Resume {!isResumeUploaded && <span className="required">*</span>}</InputLabel>
                                    <Button variant="outlined" component="label" size="small" fullWidth sx={{ mt: 1 }}                                >
                                        Upload Logo
                                        <input type="file" hidden ref={hiddenFileInput} onChange={uploadLogo} accept="application/pdf,.jpg,.jpeg,.png,.gif" />
                                    </Button>
                                    {!isResumeUploaded && (
                                        <FormHelperText error>
                                            Please upload Logo.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </div>
                            {isResumeUploaded &&
                                <div className="col-md-3 mt-4">
                                    <Button variant="contained" color="primary" startIcon={<i className="fa fa-download"></i>} onClick={downloadLogo} size="small"                                >
                                        Download Logo
                                    </Button>
                                </div>
                            }
                        </div>
                        <div className="row">
                            <div className="col-md-9">
                            </div>
                            <div className="col-md-3  text-end">
                                <Button variant="contained" color="primary" type="submit" disabled={!isValid}>
                                    Save Profile
                                </Button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};
export default InterviewsComponent;